import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../common/queryClient/getMutationFn';
import { apiClient } from '../../common/ApiClient';
import { OutputDataUrl } from './OutputDataUrl';
import { DeleteOutputDataType } from '../schema/types';

const postDeleteOutputData = async (
  request: DeleteOutputDataType,
  headers?: HttpHeaders,
) =>
  apiClient
    .post<void>(
      OutputDataUrl.OUTPUT_DATA_DELETION,
      request,
      headers ? { headers } : undefined,
    )
    .then((response) => response.data);

export const useDeleteOutputData = createApiMutationHook(
  ['deleteOutputData'],
  getMutationFn(postDeleteOutputData),
);
